// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__sWSMO","description":"PatientConsentPreview_description__2PSbU"};